import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import testable from '@xingternal/malt-util/testable';
import { QA_MALT } from '@xingternal/malt-constants';

import styles from './Message.css';
import { IconMessageSpam, IconCoreInfo } from '@xingternal/malt-icon';

const TestableDiv = testable(QA_MALT, 'div');

const Message = ({ headline, children, type, className, small, testId }) => {
  const IconElement = type === 'error' ? IconMessageSpam : IconCoreInfo;
  return (
    <TestableDiv
      className={classnames(className, styles.message, styles[type], {
        [styles.responsive]: !small,
        [styles.noHeadline]: !headline,
      })}
      testId={testId}
    >
      <IconElement className={styles.icon} size={small ? 20 : 32} />
      <div className={styles.body}>
        {headline && <div className={styles.headline}>{headline}</div>}
        <p className={styles.text}>{children}</p>
      </div>
    </TestableDiv>
  );
};

Message.defaultProps = {
  small: false,
};

Message.propTypes = {
  /** message body as string text or react children */
  children: PropTypes.node.isRequired,
  /** has to be one of information, error */
  type: PropTypes.oneOf(['error', 'information']).isRequired,
  /** renders an optional headline */
  headline: PropTypes.node,
  /** add a custom className to the component */
  className: PropTypes.string,
  /** defines if the small display has to be used */
  small: PropTypes.bool,
  /** define a testid for the messsage */
  testId: PropTypes.string,
};

Message.displayName = 'Message';

export default Message;
